var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cool-select',{attrs:{"list":_vm.getAvailableAddressIncludingCurrentlySelected,"option-value":"addressFullName","option-text":"displayName","placeholder":_vm.$t('CONTENT.choose')},model:{value:(_vm.selectModel),callback:function ($$v) {_vm.selectModel=$$v},expression:"selectModel"}})
}
var staticRenderFns = []

export { render, staticRenderFns }